import { useContext, useEffect, useRef, useState } from "react";
import { CurrentPContext, MasterContext, MobiOrNotContext, OrderContext, OrdStageContext, ScreenWidthContext } from "../ContextApi/context";
import { ArrowCircleDownSharp, ArrowCircleUp, ArrowBackIosNew, ArrowCircleRightSharp, Height, QrCodeScannerOutlined } from '@mui/icons-material';

import { Prompt, useHistory } from "react-router";
import "react-datepicker/dist/react-datepicker.css";
import myFunctions from "../myFunctions";
import parse from 'html-react-parser';
import utilsTablesOrders from "../_Utils/utilsTablesOrders";
import tblOrdTimes from "./tblOrdTimes";
import DropNumbersSelection from "./OrderTableItems/DropNumbersSelection";
import DatePick from "./OrderTableItems/DatePick";
import DropHouresSelection from "./OrderTableItems/DropHouresSelection";
import TableOrder_Confirmd from "./Pop_Fixed/TableOrder_Confirmd";

const OrderPlaceOnRest = (props) => {
    const history = useHistory();
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [master] = useContext(MasterContext);

    const [clientName, setClientName] = useState("")
    const [clientPhone, setClientPhone] = useState("")
    const [remarks, setRemarks] = useState("")
    const [dinners, setDinners] = useState(2)
    const [dateToCome, setDateToCome] = useState(null)
    const [timeToCome, setTimeToCome] = useState("")
    const [showOrdBtn, setShowOrdBtn] = useState(true)
    const [sending, setSending] = useState(false)
    const [erMsg, setErMsg] = useState("");
    const [thePopUp, setThePopUp] = useState("");

    const [availableSlots, setAvailableSlots] = useState([])

    //התאריך שעליו כבר חושבה רשימת השעות, כדי להבדיל בין החלפת תאריך לרענון ההגדרות
    const lastDateKey = useRef(null);

    //הימים והשעות מגיעים מההגדרות בניהול. אין הגדרות - אין הזמנות
    const theSettings = master ? master.tblOrdSettings : null;

    //פותחים על התאריך הפנוי הקרוב ביותר ולא על היום
    useEffect(() => {
        setDateToCome(tblOrdTimes.findFirstAvailableDate(theSettings, new Date()));
    }, [master])

    //רשימת השעות נגזרת מהתאריך שנבחר, ולכן מתעדכנת בכל החלפת תאריך
    useEffect(() => {
        let slots = (dateToCome) ? tblOrdTimes.getAvailableSlots(theSettings, dateToCome, new Date()) : [];
        setAvailableSlots(slots);

        //בכל החלפת תאריך קופצים לשעה הראשונה שמתאפשרת באותו תאריך.
        //בחירה של המשתמש נשמרת רק כשהרשימה התרעננה על אותו תאריך (למשל עדכון הגדרות)
        const curDateKey = (dateToCome) ? tblOrdTimes.dayKey(dateToCome) : null;
        const dateChanged = (curDateKey !== lastDateKey.current);
        lastDateKey.current = curDateKey;

        setTimeToCome((prevTime) =>
            (!dateChanged && slots.indexOf(prevTime) !== -1) ? prevTime : ((slots.length > 0) ? slots[0] : ""));
    }, [dateToCome, master])


    const orderMeTable = async () => {
        let errMsg = "";

        if (clientName != "") {
        }
        else {
            errMsg = "יש להזין שם מלא"
        }

        if (errMsg == "") {
            if (clientPhone != "") {
                let chk = myFunctions.validPhone(clientPhone);
                if (chk == "") {
                }
                else {
                    errMsg = "יש להזין מספר טלפון תקין"
                }
            }
            else {
                errMsg = "יש להזין מספר טלפון תקין"
            }
        }

        if (errMsg === "") {
            if (!dateToCome || timeToCome === "") {
                errMsg = "יש לבחור תאריך ושעה";
            }
            else if (tblOrdTimes.getAvailableSlots(theSettings, dateToCome, new Date()).indexOf(timeToCome) === -1) {
                errMsg = "השעה שנבחרה אינה זמינה להזמנה, יש לבחור שעה אחרת";
            }
        }

        if (errMsg === "") {
            const selectedDateTime = new Date(dateToCome);
            const selectedHourTime = timeToCome.split(":");
            selectedDateTime.setHours(parseInt(selectedHourTime[0], 10)); // Convert string to integer
            selectedDateTime.setMinutes(parseInt(selectedHourTime[1], 10)); // Convert string to integer

            let SelTime = new Date(selectedDateTime)
            const currentDateTime = new Date();

            if (SelTime < currentDateTime) {
                errMsg = "לא ניתן להזמין לזמן שעבר כבר";
            }
        }


        //הכל תקין שולח הזמנה
        if (errMsg == "") {
            setSending(true)
            let theParms = {
                clientName, clientPhone, dinners, timeToCome,
                dateToCome,
                //התאריך היומי במפורש, כדי שהשרת (שרץ ב-UTC) לא יזיז את היום אחורה
                dateKey: tblOrdTimes.dayKey(dateToCome),
                remarks
            }
            let sndMsg = await utilsTablesOrders.createTableOrder(theParms);

            if (sndMsg && sndMsg.msg == "approved") {
                setThePopUp(<TableOrder_Confirmd
                    TblorderNumber={sndMsg.orderNumber}
                    okClick={() => props.closePop()} />)
            }
            else if (sndMsg && sndMsg.msg == "notAvailable") {
                //ההגדרות בניהול השתנו בין רגע פתיחת הטופס לרגע השליחה
                setErMsg("השעה שנבחרה כבר אינה זמינה, יש לבחור מועד אחר")
                setDateToCome(tblOrdTimes.findFirstAvailableDate(theSettings, new Date()));
                setSending(false)
            }
            else {
                setErMsg("לא הצלחנו לבצע הזמנה, נסה שוב")
                setSending(false)
            }
        }
        else {
            setErMsg(errMsg)
        }
    }


    const wrpaStyl = (!mobiOrNot) ?
        { position: 'relative', float: 'right', width: '30%' } :
        { position: 'relative', width: '100%' };

    const DtPickwrpaStyl = (!mobiOrNot) ?
        { position: 'relative', float: 'right', width: '130%' } :
        { position: 'relative', width: '100%' };

    const selectionstyl =
        { position: 'fixed', zIndex: 1 };

    const wrpaStylwithSpaceRight = (!mobiOrNot) ?
        { position: 'relative', float: 'right', right: '19px' } :
        { position: 'relative' };


    //עוד לא נטען המאסטר
    if (!master) {
        return (
            <div className={"orderPlaceBlock"}>
                <div className={"erMsg"}>טוען...</div>
            </div>
        );
    }

    //אין שום מועד פנוי - חסימה גורפת, או שעדיין לא הוגדרו ימים ושעות בניהול
    if (!dateToCome) {
        return (
            <div className={"orderPlaceBlock"}>
                <div className={"fullRow overflowHid"}>
                    <div className={"erMsg fullRow"}>
                        <p className={"pMssge"}>הזמנת שולחנות אינה זמינה כרגע</p>
                    </div>
                </div>
                <div className={"btnsPopWrap spaceMargTopVBig"}>
                    <button type="button" className="btnPopRegular pointing"
                        onClick={() => props.closePop()}>סגור</button>
                </div>
            </div>
        );
    }

    return (
        <div className={"orderPlaceBlock"}>
            <div className={"orderPlaceBlockWrap"}>
                    <DropNumbersSelection
                        drpArrCss={"drpArrowWhite"}
                        wrpaStyl={wrpaStyl}
                        selectionstyl={selectionstyl}
                        lbl="אנשים"
                        Typ="text"
                        Css="inputsDropDownStyle"
                        Val={dinners}
                        placeholder="מספר סועדים"
                        settingFunc={(val) => setDinners(val)}
                        maxNumb={50}
                    />

                    <DatePick
                        drpArrCss={"drpArrowWhite"}
                        wrpaStyl={DtPickwrpaStyl}
                        lbl="ל"
                        settingFunc={(val) => setDateToCome(val)}
                        Css="inputsStyle pointing"
                        selectedDate={dateToCome}
                        minDate={new Date()}
                        filterDate={(dt) => tblOrdTimes.isDateAvailable(theSettings, dt, new Date())}
                    />

                    <DropHouresSelection
                        drpArrCss={"drpArrowWhite"}
                        wrpaStyl={wrpaStylwithSpaceRight}
                        selectionstyl={selectionstyl}
                        lbl="לשעה"
                        Typ="text"
                        Css="inputsDropDownStyle"
                        Val={timeToCome}
                        placeholder="לשעה"
                        settingFunc={(val) => setTimeToCome(val)}
                        slots={availableSlots}
                    />
            </div>
            <div className={"orderPlaceBlockWrap ord2"}>
                <div className={(!mobiOrNot) ? "onRight txConInput" : ""}>
                    <input type={"text"}
                        className={"contactInput"}
                        value={clientName}
                        placeholder={"שם מלא"}
                        onChange={(e) => { setClientName(e.target.value) }} />

                </div>
                <div className={(!mobiOrNot) ? "onLeft smallRIght txConInput" : ""}
                >

                    <input type={"text"}
                        className={"contactInput"}
                        value={clientPhone}
                        placeholder={"טלפון"}
                        onChange={(e) => { setClientPhone(e.target.value) }} />
                </div>
            </div>
            <div className={"orderPlaceBlockWrap ord2"}>
                <div>
                    <textarea
                        className={"remarksInput"}
                        value={remarks}
                        placeholder={"הערות"}
                        onChange={(e) => { setRemarks(e.target.value) }} >
                    </textarea>
                </div>
            </div>

            <div className={"fullRow overflowHid"}>
                <div className={"erMsg fullRow"}>
                    <p style={{ minHeight: '20px' }} className={"pMssge"}>{parse(erMsg)}</p></div>
            </div>


            {
                (!sending) ?
                    <div className={"btnsPopWrap spaceMargTopVBig"}>
                        {
                            <button type="button" className="btnPopRegular pointing"
                                onClick={() => { (!showOrdBtn) ? props.closePop() : orderMeTable() }}>
                                {(!showOrdBtn) ? "סגור" : (props.BtnTxt != null) ? props.BtnTxt : "מצאו לי שולחן"}</button>
                        }
                    </div> :
                    <div className={"erMsg"}>שולח...</div>
            }

            {thePopUp}
        </div>
    );
}

export default OrderPlaceOnRest;
